module.exports = __webpack_public_path__ + "img/calendar.b050846f.png";